/* Enord Core classic v1.2 — Results slideshow: arrows + accordion + photo lightbox (v1.2). */
(function(){
  var lb;
  function lightbox(){
    if(lb)return lb;
    lb=document.createElement('div');lb.className='ers-lbx';lb.setAttribute('role','dialog');lb.setAttribute('aria-modal','true');
    lb.innerHTML='<button type="button" class="ers-lbx-x" aria-label="Close"></button><img alt="">';
    function close(){lb.classList.remove('is-on');document.body.classList.remove('ers-lbx-open')}
    lb.addEventListener('click',function(e){if(e.target===lb||e.target.classList.contains('ers-lbx-x'))close()});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
    document.body.appendChild(lb);
    return lb;
  }
  function bigSrc(img){
    var ss=img.getAttribute('srcset');
    if(ss){var best=null,bw=0;ss.split(',').forEach(function(c){var p=c.trim().split(/\s+/),w=parseInt(p[1]||'0',10);if(w>bw){bw=w;best=p[0]}});if(best)return best}
    return img.currentSrc||img.src;
  }
  function init(root){
    if(root.__ers)return;root.__ers=1;
    var tr=root.querySelector('[data-ers-track]'),pv=root.querySelector('[data-ers-prev]'),nx=root.querySelector('[data-ers-next]');
    if(!tr)return;
    function sync(){
      var max=tr.scrollWidth-tr.clientWidth-1,x=tr.scrollLeft;
      if(pv)pv.style.visibility=(max>0&&x>1)?'visible':'hidden';
      if(nx)nx.style.visibility=(max>0&&x<max)?'visible':'hidden';
    }
    function step(d){var s=tr.querySelector('.ers-slide');tr.scrollBy({left:d*(s?s.getBoundingClientRect().width:tr.clientWidth),behavior:'smooth'})}
    tr.addEventListener('scroll',sync,{passive:true});
    window.addEventListener('resize',sync);
    if(pv)pv.addEventListener('click',function(){step(-1)});
    if(nx)nx.addEventListener('click',function(){step(1)});
    root.querySelectorAll('[data-ers-bt]').forEach(function(b){
      var pn=b.parentNode.querySelector('[data-ers-pn]');
      b.addEventListener('click',function(){
        var open=b.getAttribute('aria-expanded')==='true';
        b.setAttribute('aria-expanded',open?'false':'true');
        pn.style.height=open?'0px':pn.scrollHeight+'px';
        setTimeout(sync,380);
      });
    });
    root.querySelectorAll('.ers-ph img').forEach(function(img){
      img.style.cursor='zoom-in';
      img.addEventListener('click',function(){
        var l=lightbox(),big=l.querySelector('img');
        big.src=bigSrc(img);big.alt=img.alt||'';
        l.classList.add('is-on');document.body.classList.add('ers-lbx-open');
      });
    });
    sync();
    if(window.ResizeObserver)new ResizeObserver(sync).observe(tr);
  }
  function all(){document.querySelectorAll('[data-ers]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();
